export default {
    primary: '#1f3bb0',
    primaryLight: '#a0abb6',
    primaryDark: '#17203a',
    secondary: '#112060',
    darkGreyBlue: '#2e384d',
    lightBlue: '#0499fe',
    orange: '#ff8a00',
    green: '#33aa44'
}
